import React from "react";
const Q2 = () => {
  return (
    <div style={{ backgroundColor: "#Dbe6ea" }}>
      <div className="ans-bank">
        <div className="qta">What are odds?</div>
        <p>
          The total number of eligible entries received determines theodds of
          winning.
        </p>
      </div>
    </div>
  );
};

export default Q2;
